import { render, staticRenderFns } from "./HistoryInventoryQuotas.vue?vue&type=template&id=3a00d4b4"
import script from "./HistoryInventoryQuotas.vue?vue&type=script&lang=js"
export * from "./HistoryInventoryQuotas.vue?vue&type=script&lang=js"
import style0 from "./HistoryInventoryQuotas.vue?vue&type=style&index=0&id=3a00d4b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports